<script setup lang="ts">
    interface Props {
        name?: string;
        url?: string;
        lang?: string;
        type?: 'pdf' | 'jpeg' | 'png' | 'doc' | 'oth';
    }

    const props = defineProps<Props>();
</script>
<template>
    <div class="link-wrapper">
        <a
            target="_blank"
            :href="url"
        >
            <img
                v-if="props.type == 'jpeg' || props.type == 'png'"
                src="~/assets/icons/file-image.svg"
                alt="picture-icon"
            />
            <img
                v-if="props.type == 'pdf' || props.type == 'doc'"
                src="~/assets/icons/file-text.svg"
                alt="file-icon"
            />
            <img
                v-if="props.type == 'oth'"
                src="~/assets/icons/download.svg"
                alt="download-icon"
            />
            <p class="link-name">{{ props.name }}</p>

            <span
                v-if="props.lang"
                class="lang"
            >
                ({{ props.lang }})</span
            >
        </a>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/download.scss';
</style>
